import { CoreDialogActions } from '@youscience/core';

import { camelize } from '@utils/formatter';

import ActionButton from '@components/ActionButton';

import { sxStyles } from './DialogFooter.styles';

interface DialogFooterProps {
  backButtonTitle?: string;
  backActionButtonTitle?: string;
  saveChangesButtonTitle?: string;
  saveChangesActionButtonTitle?: string;
  continueButtonTitle?: string;
  continueActionButtonTitle?: string;

  onGoBack?: () => Promise<void> | void;
  onSaveChanges?: () => Promise<void> | void;
  onContinue?: () => Promise<void> | void;
}

export const DialogFooter = (props: DialogFooterProps) => {
  const {
    backButtonTitle = 'Back',
    backActionButtonTitle,
    saveChangesButtonTitle = 'Save changes',
    saveChangesActionButtonTitle,
    continueButtonTitle = 'Continue',
    continueActionButtonTitle,
    onGoBack,
    onSaveChanges,
    onContinue,
  } = props;

  return (
    <CoreDialogActions data-testid="dialogFooter" sx={sxStyles.footer}>
      {onGoBack && backButtonTitle ? (
        <ActionButton
          size="large"
          data-testid={`${camelize(backButtonTitle)}Btn`}
          variant="text"
          onClick={onGoBack}
          busyText={backActionButtonTitle}
        >
          {backButtonTitle}
        </ActionButton>
      ) : null}

      {onSaveChanges && saveChangesButtonTitle ? (
        <ActionButton
          size="large"
          data-testid={`${camelize(saveChangesButtonTitle)}Btn`}
          variant="outlined"
          onClick={onSaveChanges}
          busyText={saveChangesActionButtonTitle}
        >
          {saveChangesButtonTitle}
        </ActionButton>
      ) : null}

      {onContinue && continueButtonTitle ? (
        <ActionButton
          size="large"
          data-testid={`${camelize(continueButtonTitle)}Btn`}
          onClick={onContinue}
          busyText={continueActionButtonTitle}
        >
          {continueButtonTitle}
        </ActionButton>
      ) : null}
    </CoreDialogActions>
  );
};
